const apiUrl = process.env.REACT_APP_API_URL;

export interface JobConfig {
    id: number;
    nom: string;
    descripcio: string;
    cron: string;
    actiu: number;
    ultimaExecucio: string | null;
    properLlancament: string | null;
}

/** Retorna la configuració de tots els jobs (cron, estat, proper llançament). */
export const GetJobsConfig = async (page: string): Promise<JobConfig[]> => {
    try {
        const response = await fetch(`${apiUrl}:8072/jobs/config`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (!response.ok) return [];
        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error('Error obtenint la configuració dels jobs', error);
        return [];
    }
};
